/* eslint-disable jsx-a11y/anchor-is-valid */
import { useIntersectionObserver, useWindowSize } from "@uidotdev/usehooks";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import esclip1 from "../../assets/imgs/homepage/Ellipse 154.png";
import esclip from "../../assets/imgs/homepage/Ellipse 155.png";
import girl from "../../assets/imgs/homepage/Rectangle-Copy.png";
import balance from "../../assets/svgs/apibanking/blacee.svg";
import bulk from "../../assets/svgs/apibanking/bulk.svg";
import online from "../../assets/svgs/apibanking/connect.svg";
import cafehrer from "../../assets/svgs/apibanking/customer.svg";
import retail from "../../assets/svgs/apibanking/eas.svg";
import soundbox from "../../assets/svgs/bpps/bbps.svg";
import bankacc from "../../assets/svgs/bpps/choose.svg";
import cafe from "../../assets/svgs/bpps/encourages.svg";
import checkhow from "../../assets/svgs/bpps/fetch.svg";
import recon from "../../assets/svgs/bpps/make.svg";
import esay from "../../assets/svgs/bpps/select.svg";
import sound from "../../assets/svgs/bpps/sound.svg";
import check from "../../assets/svgs/check.svg";
import frequent from "../../assets/svgs/frenquent.svg";
import payment from "../../assets/svgs/payment.svg";
import poor from "../../assets/svgs/poor.svg";
import { AccordionComponent } from "../../components/accordions";
import { ButtonNumber, LeafButton } from "../../components/buttons";
import { Contact } from "../../components/contact/Contact";
import { SliderBbps } from "../../components/slicksdiler";
import {
  HaveALookItem,
  SolutionItem,
  SoundBoxWorkItem,
} from "../../components/soundboxwork";
import { UpiSoundboxItem } from "../../components/upisoundbox/UpiSoundboxItem";

export const Bbps = () => {
  const { width } = useWindowSize();
  const { t, i18n } = useTranslation();

  const [currentTitle, setCurrentTitle] = useState(t("bbsp.cost"));
  const [currentHeader, setCurrentHeader] = useState(t("bbsp.costdes"));
  const handleButtonClick1 = () => {
    setCurrentTitle(t("bbsp.cost"));
    setCurrentHeader(t("bbsp.costdes"));
  };

  const handleButtonClick2 = () => {
    setCurrentTitle(t("bbsp.customniable"));
    setCurrentHeader(t("bbsp.customniabledes"));
  };
  const handleButtonClick3 = () => {
    setCurrentTitle(t("bbsp.roundthe"));
    setCurrentHeader(t("bbsp.roundthedes"));
  };
  const handleButtonClick4 = () => {
    setCurrentTitle(t("bbsp.secured"));
    setCurrentHeader(t("bbsp.securedes"));
  };
  const handleButtonClick5 = () => {
    setCurrentTitle(t("bbsp.year"));
    setCurrentHeader(t("bbsp.yeardes"));
  };
  useEffect(() => {
    if (activeButton == 1) {
      setCurrentTitle(t("bbsp.cost"));
      setCurrentHeader(t("bbsp.costdes"));
    } else if (activeButton == 2) {
      setCurrentTitle(t("bbsp.customniable"));
      setCurrentHeader(t("bbsp.customniabledes"));
    } else if (activeButton == 3) {
      setCurrentTitle(t("bbsp.roundthe"));
      setCurrentHeader(t("bbsp.roundthedes"));
    } else if (activeButton == 4) {
      setCurrentTitle(t("bbsp.secured"));
      setCurrentHeader(t("bbsp.securedes"));
    } else {
      setCurrentTitle(t("bbsp.year"));
      setCurrentHeader(t("bbsp.yeardes"));
    }
  }, [t]);

  const [activeButton, setActiveButton] = useState(1); // State để theo dõi nút hiện đang được kích hoạt

  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber); // Cập nhật state để chỉ định nút được kích hoạt
  };
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref1, entry1] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref2, entry2] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });

  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  useEffect(() => {
    if (entry && entry.isIntersecting && !isVisible) {
      setIsVisible(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry, isVisible]);
  useEffect(() => {
    if (entry1 && entry1.isIntersecting && !isVisible1) {
      setIsVisible1(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry1, isVisible1]);
  useEffect(() => {
    if (entry2 && entry2.isIntersecting && !isVisible2) {
      setIsVisible2(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry2, isVisible2]);

  return (
    <div className="relative mt-[145px]">
      <Helmet>
        <title>BBPS API | Trusted Pay</title>
      </Helmet>
      <img className="absolute left-0 top-[0]" src={esclip} alt="" />
      <img className="absolute right-0 top-[0]" src={esclip1} alt="" />
      <div className="absolute left-[50%] top-[50px] h-[24px] w-[24px] animate-movesquare rounded-[24px] bg-[#FF9B26]"></div>
      <div className="absolute left-[40%] top-[450px] h-[42px] w-[39px] animate-movesquare-slow rounded-[24px] bg-[#565ADD]"></div>

      {/* SOUNDBOX */}
      <div className="relative mx-auto max-w-[1280px] px-4 mothaibaysaimin:px-8">
        {width > 1024 ? (
          <div className="flex items-center gap-[30px] sm:flex-col">
            <div className="max-w-[700px] ">
              <p className="animate-fadeInDown text-[40px] font-bold text-[--color-text]">
                {t("bbsp.header")}
              </p>
              <div className="animate-fadeInUp">
                <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text]">
                  {t("bbsp.there")}
                </p>
                <LeafButton
                  title={t("apibanking.contactsale")}
                  style={{ marginTop: "36px" }}
                />
              </div>
            </div>
            <div className="relative">
              <img
                className="h-[500px] w-[606px] animate-fadeInDown sm:h-[350px] sm:w-[450px] lg:h-[400px] lg:w-[500px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 left-1/3 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex animate-fadeInDown items-center gap-[30px] sm:flex-col">
            <div className="relative">
              <img
                className="h-[500px] w-[606px] lg:w-[500px] lgmax:h-[400px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>

            <div className="max-w-[625px]">
              <p className="text-[40px] font-bold text-[--color-text] ">
                {t("bbsp.header")}
              </p>
              <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text]">
                {t("bbsp.there")}
              </p>
              <LeafButton
                title={t("apibanking.contactsale")}
                style={{ marginTop: "36px" }}
              />
            </div>
          </div>
        )}
      </div>
      <div ref={ref}>
        <div
          className={`relative mx-auto max-w-[1280px] md:px-[80px] py-[50px] px-4  ${isVisible ? "animate-fadeInUp" : null}`}
        >
          <div className="flex flex-col items-center justify-center gap-[20px]">
            <div className="group">
              <img
                src={sound}
                className=" animate-spin transition-all group-hover:animate-hover"
                alt=""
              />
            </div>

            <h1 className="max-w-[1240px] text-center text-[36px] font-bold text-[--color-title]">
              {t("bbsp.leverage")}{" "}
              <span className="text-[--color-hover]">{t("bbsp.ofBBps")}</span>
            </h1>
            <p className="text-4 max-w-[780px] text-center font-montserrat text-[--color-text]">
              {t("bbsp.ofbbpsdes1")}
              <a href="#" className="text-[#565ADD] hover:underline">
                {t("bbsp.ofbbpsdes2")}
              </a>
              {t("bbsp.ofbbpsdes")}
            </p>
          </div>
        </div>
      </div>

      <div ref={ref1}>
        <div
          className={`rounded-tr-[200px] bg-[#EFF0FF] sm:rounded-tl-[50px] sm:rounded-tr-[50px] ${isVisible1 ? "animate-fadeInUp" : null}`}
        >
          <div className="mx-auto flex max-w-[1280px] flex-col gap-[20px] px-[50px] py-[50px] sm:px-4">
            <h1 className="max-w-[1240px] text-center text-[36px] font-bold text-[--color-title]">
              {i18n.language === "vi" ? (
                <>
                  <span className="text-[--color-hover]">
                    {t("bbsp.apiwork")}
                  </span>{" "}
                  {t("bbsp.howdoestr")}
                </>
              ) : (
                <>
                  {t("bbsp.howdoestr")}{" "}
                  <span className="text-[--color-hover]">
                    {t("bbsp.apiwork")}
                  </span>
                </>
              )}
            </h1>
            <div className="flex lgmax:flex-wrap lgmax:justify-center">
              <SoundBoxWorkItem
                image={esay}
                titleheader={t("bbsp.select")}
                title={t("bbsp.selectdes")}
              />
              <SoundBoxWorkItem
                image={bankacc}
                titleheader={t("bbsp.choose")}
                title={t("bbsp.choosedes")}
              />
              <SoundBoxWorkItem
                image={checkhow}
                titleheader={t("bbsp.fetch")}
                title={t("bbsp.fetchdes")}
              />
              <SoundBoxWorkItem
                image={recon}
                titleheader={t("bbsp.make")}
                title={t("bbsp.makedes")}
              />
            </div>
          </div>
        </div>
      </div>

      <div ref={ref2}>
        <div
          className={`relative min-h-[570px]  bg-soundbox bg-cover bg-center bg-no-repeat sm:h-full   ${isVisible2 ? "animate-fadeInUp" : null}`}
        >
          <div
            className={`absolute bottom-0 left-0 right-0 top-0 min-h-[570px] bg-soundboxOverlay opacity-[0.63]
                sm:h-full `}
          ></div>
          <div className="left-26 absolute z-[100] h-0 w-48 border-dashed  border-white bg-white"></div>
          <div className={`relative  mx-auto max-w-[1280px] px-4 py-[70px]`}>
            <div>
              <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[#fff]">
                {t("bbsp.proplem")}{" "}
                <span className="text-[--color-hover]">
                  {t("bbsp.proplemdes")}
                </span>{" "}
              </h1>
              <div>
                <div className="lgmin: absolute left-[17%] top-[32.5%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="absolute left-[17%] top-[32.05%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="relative flex sm:flex-col sm:items-center sm:justify-center sm460:gap-[30px] ">
                  <UpiSoundboxItem
                    image={payment}
                    titleheader={t("bbsp.longque")}
                    title={t("bbsp.longquedes")}
                    height={
                      width > 986
                        ? "mothaibaysaimin:min-h-[350px]"
                        : "mothaibaysaimin:min-h-[370px]"
                    }
                  />
                  <UpiSoundboxItem
                    image={frequent}
                    titleheader={t("bbsp.ubintent")}
                    title={t("bbsp.ubintentdes")}
                    height={
                      width > 986
                        ? "mothaibaysaimin:min-h-[350px]"
                        : "mothaibaysaimin:min-h-[370px]"
                    }
                  />
                  <UpiSoundboxItem
                    image={poor}
                    titleheader={t("bbsp.limited")}
                    title={t("bbsp.limiteddes")}
                    height={
                      width > 986
                        ? "mothaibaysaimin:min-h-[350px]"
                        : "mothaibaysaimin:min-h-[370px]"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="min-h-[640px] bg-[#EFF0FF] sm:min-h-[240px] lg:min-h-[580px]">
        <div className="mx-auto max-w-[1400px] flex-col gap-[20px] px-[50px]  py-[50px] sm:px-[16px]">
          <h1 className="ml-[30px] max-w-[1240px] text-center text-[36px] font-bold text-[--color-title] sm:ml-0">
            {t("bbsp.benifits")}{" "}
            <span className="text-[--color-hover]">
              {t("bbsp.integration")}{" "}
            </span>
          </h1>
          <SliderBbps />
        </div>
      </div>

      <div className="relative bg-white">
        <div
          className={`mx-auto flex max-w-[1280px] items-center justify-center px-4 py-[50px] pt-[50px] sm:flex-wrap lg:flex-wrap`}
        >
          <div className="relative max-w-[640px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="sm:w-[400px]"
              width="544"
              height="544"
              viewBox="0 0 544 544"
              fill="none"
            >
              <path
                opacity="0.03"
                d="M271.751 0.350098C421.618 0.350098 543.109 121.841 543.109 271.707C543.109 421.573 421.618 543.065 271.751 543.065C121.885 543.065 0.394043 421.574 0.394043 271.707C0.394043 121.841 121.885 0.350098 271.751 0.350098Z"
                fill="#2B1C50"
              />
            </svg>
            <div className="absolute left-[60px] top-[60px] h-[420px] w-[420px] rounded-[50%] border border-dashed  border-[#565ADD] sm:left-[46px] sm:top-[124px] sm:h-[300px] sm:w-[300px]"></div>
            <img
              className="absolute left-0 top-0 ml-[95px] mt-[26px] sm:ml-[85px] sm:mt-[112px] sm:w-[268px] mothaibaysaimin:w-[383px]"
              src={girl}
              alt=""
            />
          </div>
          <div className="ml-[60px] sm:ml-0 lgmax:ml-0">
            <h1 className="max-w-[620px]  text-[36px] font-bold text-[--color-title]">
              {t("bbsp.usecase")}
              <span className="text-[--color-hover]">BBPS</span>
            </h1>

            <HaveALookItem
              image={cafe}
              titleheader={t("bbsp.encourages")}
              title={t("bbsp.encouragesdes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[64px]" : "bottom-[88px]"
              }
              paddingleft={"pl-[18px]"}
            />

            <HaveALookItem
              image={cafehrer}
              titleheader={t("bbsp.save")}
              title={t("bbsp.savedes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[16px]" : "bottom-[-8px]"
              }
              paddingleft={"pl-[18px]"}
            />

            <HaveALookItem
              image={retail}
              titleheader={t("bbsp.realtime")}
              title={t("bbsp.realtimedes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[16px]" : "bottom-[40px]"
              }
              paddingleft={"pl-[18px]"}
            />

            <HaveALookItem
              image={online}
              titleheader={t("bbsp.automate")}
              title={t("bbsp.automatedes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[64px]" : "bottom-[88px]"
              }
              paddingleft={"pl-[18px]"}
            />
          </div>
        </div>
      </div>
      <div className="rounded-t-3xl bg-pupletowhite ">
        <div className="mx-auto max-w-[1280px] flex-col justify-between px-4 py-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <h1 className="ml-[30px] pb-[15px] text-[36px]  font-bold text-white sm:ml-0">
            {t("apibanking.trustpay")}
            <span className="text-[#D1D1F7]">{t("apibanking.allin")}</span>
          </h1>
          <p className="text-4 ml-[30px] text-white sm:ml-0">
            {t("bbsp.allindes")}
          </p>
          <div className="ml-[30px] mt-[20px] flex sm:ml-0 lgmax:flex-col lgmax:gap-[30px]">
            <SolutionItem
              image={balance}
              titleheader={t("bbsp.mobile")}
              title={t("bbsp.mobiledes")}
            />
            <SolutionItem
              image={bulk}
              titleheader={t("bbsp.utilitybill")}
              title={t("bbsp.utilitybilldes")}
            />

            <div
              className={`transition-border  transition-radius mr-[30px] rounded-[20px] transition-colors transition-shadow duration-500 duration-500 duration-500  ease-in-out hover:shadow-have-a-look-hover  sm:mr-0   ${i18n.language === "en" ? (width > 1230 ? "h-[440px]" : "h-none") : ""}  relative overflow-hidden  sm:mr-0`}
            >
              <div
                className={`mb-[1px] flex max-w-[400px]   flex-col rounded-[20px] bg-white  p-[20px]  lgmax:max-w-none `}
              >
                <div className="h-[100px] w-[100px] rounded-[50px]  shadow-benefits">
                  <img className="p-[25px]" src={bulk} alt="" />
                </div>
                <div className="mt-[25px] flex flex-col gap-[10px]">
                  <h3 className="bg-[-100%] text-[24px] font-semibold text-[--color-hover]">
                    {t("bbsp.bbpsser")}
                  </h3>
                  <p className="text-4  font-normal text-[--color-text] group-hover:animate-text">
                    {t("bbsp.bbpsserdes")}{" "}
                    <a href="#" className="text-[#565add] hover:underline">
                      {t("bbsp.bbpsserdes2")}
                    </a>{" "}
                    {t("bbsp.bbpsserdes3")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white sm:py-[50px]">
        <div className="mx-auto flex max-w-[1280px] justify-between px-4 py-[50px] pt-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <div className={`mr-[10px] flex flex-1 flex-col gap-[20px]`}>
            <h1 className="max-w-[520px] text-[36px] font-bold  text-[--color-title] lgmaxmin:max-w-[850px]">
              {t("bbsp.whychoose")}
              <span className="text-[--color-hover]">BBPS</span>?
            </h1>
            <p className="text-4 max-w-[620px] font-montserrat text-[#3D2E7C] lgmaxmin:max-w-[850px]">
              {t("bbsp.whychoosedes")}
            </p>
            <div className="group flex items-start gap-[30px] p-4 sm:flex-col sm:items-center">
              <img
                className="group-hover:animate-hover sm:h-[43px] sm:w-[43px]"
                src={check}
                alt=""
              />
              <div className="sm:text-center">
                <p className="border-b-solid inline-block border-b-4 border-b-[#f1f1f1] pb-[12px] text-[24px] font-bold text-[#333]">
                  {currentTitle}
                </p>

                <p className="text-4 mt-[10px]  font-normal text-[#3D2E7C] lg:max-w-[650px]">
                  {currentHeader}
                </p>
              </div>
            </div>
            <div className="flex gap-[30px] sm:gap-[5px] ">
              <ButtonNumber
                title={"1"}
                onClick={() => {
                  handleButtonClick1();
                  handleButtonClick(1);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 1}
              />
              <ButtonNumber
                title={"2"}
                onClick={() => {
                  handleButtonClick2();
                  handleButtonClick(2);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 2}
              />
              <ButtonNumber
                title={"3"}
                onClick={() => {
                  handleButtonClick3();
                  handleButtonClick(3);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 3}
              />
              <ButtonNumber
                title={"4"}
                onClick={() => {
                  handleButtonClick4();
                  handleButtonClick(4);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 4}
              />
              <ButtonNumber
                title={"5"}
                onClick={() => {
                  handleButtonClick5();
                  handleButtonClick(5);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 5}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-[20px]  lg:mt-[20px] lgmax:mt-[20px]">
            <h1 className="max-w-[520px] text-[36px] font-bold text-[--color-title]">
              FA<span className="text-[--color-hover]">Q's</span>
            </h1>
            <AccordionComponent
              header1={t("bbsp.what")}
              des1={t("bbsp.whatdes")}
              header2={t("bbsp.howdoes")}
              des2={t("bbsp.howdoesdes")}
              header3={t("bbsp.howto")}
              des3={t("bbsp.howtodes")}
              header4={t("bbsp.whatType")}
              des4={t("bbsp.whatTypeDesc")}
              header5={t("bbsp.isthere")}
              des5={t("bbsp.istheredes")}
            />
          </div>
        </div>
      </div>

      <Contact
        header={t("apibanking.contact")}
        headertitle={t("apibanking.withus")}
        headerdes={t("bbsp.connectdes")}
      />
    </div>
  );
};
